import {StyleSheet} from 'react-native';

import {orangeLight, yellowDarker} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  progressBar: {
    height: 5,
    borderRadius: 0,
    backgroundColor: yellowDarker,
  },
  progressBarFill: {
    borderRadius: 0,
    backgroundColor: orangeLight,
  },
});
